(function () {
    'use strict';

    angular
        .module('sempraWebapp')
        .controller('RolloverStatisticsController', RolloverStatisticsController);

    /** @ngInject */
    function RolloverStatisticsController(
        $scope,
        $state,
        $stateParams,
        $q,
        $mdDialog,
        $translate,
        $timeout,
        dashboardKarcherActions,
        layoutActions,
        dialogsService
    ) {
        var vm = this;

        vm.siteId = $stateParams.siteId;
        vm.selectedReport = 'washingPrograms';
        vm.washType = 'issued';
        vm.activeWashType = 'issued';
        vm.dateFrom = null;
        vm.dateTo = null;
        vm.statisticsData = [];
        vm.executedWashesData = [];
        vm.programOptions = [];
        vm.isLoading = false;

        vm.onReportChange = onReportChange;
        vm.onWashTypeChange = onWashTypeChange;
        vm.search = search;
        vm.goBack = goBack;
        vm.hasOption = hasOption;
        vm.showVoucherDetails = showVoucherDetails;
        vm.vouchersForPrint = [];

        init();

        function init() {
            loadProgramOptions();
            loadStatistics();
        }

        function loadProgramOptions() {
            if (!vm.siteId) {
                vm.programOptions = [];
                return;
            }
            dashboardKarcherActions.getRolloverSiteOptions(vm.siteId).then(
                function (response) {
                    vm.programOptions = response || [];
                },
                function (error) {
                    console.error('Error loading program options:', error);
                    vm.programOptions = [];
                }
            );
        }

        function loadStatistics() {
            if (vm.selectedReport === 'washingPrograms') {
                loadWashingProgramsStatistics();
            }
        }

        function loadWashingProgramsStatistics() {
            vm.isLoading = true;
            layoutActions.showLoader();
            
            var dateFrom = vm.dateFrom ? vm.dateFrom.toISOString() : null;
            var dateTo = vm.dateTo ? vm.dateTo.toISOString() : null;
            
            dashboardKarcherActions.getRolloverStatistics(vm.siteId, dateFrom, dateTo).then(
                function (response) {
                    vm.statisticsData = response || [];
                    vm.isLoading = false;
                    layoutActions.hideLoader();
                },
                function (error) {
                    console.error('Error loading statistics:', error);
                    vm.statisticsData = [];
                    vm.isLoading = false;
                    layoutActions.hideLoader();
                }
            );
        }

        function hasOption(row, optionId) {
            if (!row.optionIds || !optionId) {
                return false;
            }
            var optionIdStr = String(optionId);
            var optionIdsArray = row.optionIds.split(',');
            return optionIdsArray.indexOf(optionIdStr) !== -1;
        }

        function onReportChange() {
            loadStatistics();
        }

        function onWashTypeChange() {
            // Do nothing - search only on button click
        }

        function search() {
            vm.activeWashType = vm.washType;
            if (vm.washType === 'executed') {
                loadExecutedWashes();
            } else {
                loadStatistics();
            }
        }

        function loadExecutedWashes() {
            vm.isLoading = true;
            layoutActions.showLoader();
            
            var dateFrom = vm.dateFrom ? vm.dateFrom.toISOString() : null;
            var dateTo = vm.dateTo ? vm.dateTo.toISOString() : null;
            
            dashboardKarcherActions.getRolloverExecutedWashes(vm.siteId, dateFrom, dateTo).then(
                function (response) {
                    vm.executedWashesData = response || [];
                    vm.isLoading = false;
                    layoutActions.hideLoader();
                },
                function (error) {
                    console.error('Error loading executed washes:', error);
                    vm.executedWashesData = [];
                    vm.isLoading = false;
                    layoutActions.hideLoader();
                }
            );
        }

        function goBack() {
            $state.go('app.rolloverPrograms', { siteId: vm.siteId });
        }

        function showVoucherDetails(row) {
            if (!row || !row.code) {
                return;
            }
            
            layoutActions.showLoader();
            dashboardKarcherActions.getRolloverVouchersBySite(vm.siteId, 0, 1, row.code).then(
                function (response) {
                    layoutActions.hideLoader();
                    var vouchers = response.content || [];
                    if (vouchers.length === 0) {
                        return;
                    }
                    var voucher = vouchers.find(function(v) {
                        return v.voucherCode && v.voucherCode.toLowerCase() === row.code.toLowerCase();
                    });
                    if (!voucher) {
                        voucher = vouchers[0];
                    }
                    showVoucherDetailDialog(voucher);
                },
                function () {
                    layoutActions.hideLoader();
                }
            );
        }

        function showVoucherDetailDialog(voucher) {
            $mdDialog.show({
                controller: VoucherDetailDialogController,
                controllerAs: 'dialog',
                templateUrl: 'app/rollover/rolloverVoucherDetailDialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                escapeToClose: true,
                locals: {
                    voucher: voucher,
                    onPrintVoucher: function(v) {
                        vm.vouchersForPrint = [v];
                        $timeout(function () {
                            window.print();
                        }, 100);
                    },
                    onDeactivateVoucher: function(v) {
                        if (v.status !== 'ACTIVE') {
                            return;
                        }
                        dialogsService.showConfirmDialog(
                            "ROLLOVER_DEACTIVATE_TITLE",
                            "ROLLOVER_DEACTIVATE_CONFIRM",
                            "PROCEED"
                        ).then(function () {
                            layoutActions.showLoader();
                            dashboardKarcherActions.deactivateRolloverVoucher(v.id).then(
                                function () {
                                    layoutActions.hideLoader();
                                    search();
                                },
                                function () {
                                    layoutActions.hideLoader();
                                }
                            );
                        });
                    }
                }
            });
        }

        /** @ngInject */
        function VoucherDetailDialogController($mdDialog, voucher, onPrintVoucher, onDeactivateVoucher, $translate, dashboardKarcherActions) {
            var dialog = this;
            dialog.voucher = voucher;
            dialog.isUnlimited = voucher.tokensAmount === -1;
            dialog.remainingWashes = dialog.isUnlimited ? 0 : (voucher.tokensAmount || 0) - (voucher.redeemedTokens || 0);
            dialog.isRedeemed = voucher.status === 'REDEEMED';
            dialog.isExpired = voucher.status === 'EXPIRED';
            dialog.isBlocked = voucher.status === 'BLOCKED';
            dialog.isActive = voucher.status === 'ACTIVE';
            dialog.redeems = [];
            dialog.isLoadingRedeems = true;

            dialog.getStatusLabel = function() {
                return $translate.instant('ROLLOVER_STATUS_' + voucher.status);
            };

            dialog.close = function() {
                $mdDialog.hide();
            };

            dialog.printVoucher = function() {
                $mdDialog.hide();
                onPrintVoucher(voucher);
            };

            dialog.deactivateVoucher = function() {
                $mdDialog.hide();
                onDeactivateVoucher(voucher);
            };

            if (voucher.id) {
                dashboardKarcherActions.getRolloverVoucherRedeems(voucher.id).then(
                    function (data) {
                        dialog.redeems = data || [];
                        dialog.isLoadingRedeems = false;
                    },
                    function () {
                        dialog.redeems = [];
                        dialog.isLoadingRedeems = false;
                    }
                );
            } else {
                dialog.isLoadingRedeems = false;
            }
        }
    }
})();
